
import { IGetItemsParams } from '../api/types/IGetItemsParams';
import { ICompositeFilterClause, ILeafFilterClause } from '../api/types/IFilterClause';
import { IOrderClause } from '../api/types/IOrderClause';
import { IPage } from '../api/types/IPage';
import { OrderClauses } from './Order';
import { Filter } from './Filter';
import { Page } from './Page';

export class GetItemsParams implements IGetItemsParams {
  public readonly page: Page;
  public readonly filter: Filter;
  public readonly order: OrderClauses;
  public readonly statFields: string[];

  public constructor(page?: IPage, filter?: ICompositeFilterClause, order?: IOrderClause[], statFields?: string[]) {
    this.page = (page instanceof Page) ? page : new Page(page);
    this.filter = (filter instanceof Filter) ? filter : new Filter(filter);
    this.order = (order instanceof OrderClauses) ? order : new OrderClauses(order);
    this.statFields = statFields ? statFields : [];
  }

  public withPage(page?: IPage): GetItemsParams {
    return new GetItemsParams(page, this.filter, this.order);
  }

  public from(startIndex: number): GetItemsParams {
    return this.withPage(this.page.from(startIndex));
  }

  public size(maxItems: number): GetItemsParams {
    return this.withPage(this.page.size(maxItems));
  }

  /*
   Up to but including the given index
   */
  public to(endIndex: number): GetItemsParams {
    return this.withPage(this.page.to(endIndex));
  }

  public next(numberOfItems?: number): GetItemsParams {
    return this.withPage(this.page.next(numberOfItems));
  }

  public withFilter(filter?: ICompositeFilterClause): GetItemsParams {
    return new GetItemsParams(this.page, filter, this.order);
  }

  public and(leafClauseFilter: ILeafFilterClause): GetItemsParams {
    return this.withFilter(this.filter.and(leafClauseFilter));
  }

  public withOrder(order?: OrderClauses): GetItemsParams {
    return new GetItemsParams(this.page, this.filter, order);
  }

  public prependAscField(field: string): GetItemsParams {
    return this.withOrder(this.order.prependAscField(field));
  }

  public prependDescField(field: string): GetItemsParams {
    return this.withOrder(this.order.prependDescField(field));
  }
}
